export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {range, bind} from 'kpc/components/utils';
import type {TransferDataItem} from 'kpc';

interface Props {
    data: TransferDataItem[]
    value?: number[]
}

const data: TransferDataItem[] = range(1, 100).map(item => {
    return {
        label: `主机名${item}`,
        key: item
    };
});

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            data: data,
            value: []
        }
    }

    @bind
    onChangePage(model: 'left' | 'right', data: { value: number, limit: number }) {
        console.log(`${model} panel: page ${data.value}, limit ${data.limit}`);
    }

    @bind
    customFilter(item: TransferDataItem, keywords: string) {
        const label = item.label as string;
        const matchKeywords = label.toLowerCase().includes(keywords.toLowerCase());
        return matchKeywords;
    }
}